export const addAdvertisingTag = marketConfig => {
    const baxter = marketConfig.get('advertising');
    const file = marketConfig.get('siteCode');

    /* global window */
    if (baxter.enabled) {
        window.addEventListener('firstTrackingCreated', () => {
            const element = document.createElement('script');

            element.type = 'text/javascript';
            element.src = `${baxter.host}${baxter.baxterPath}${file}${baxter.fileExt}`;
            element.id = 'baxter-script';
            element.defer = true;

            document.body.appendChild(element);

            // Load CSS File For Advertisement
            // Delete after Enabling Baxter UI/API
            const headElem = document.getElementsByTagName('head')[0];

            const linkElement = document.createElement('link');

            linkElement.id = 'baxter-style-id-'.concat(file, '.css');
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            linkElement.href = `${baxter.host}${baxter.baxterPath}${file}.css`;
            linkElement.media = 'all';
            headElem.appendChild(linkElement);
        });
    }
};
